import Request from "@/services/westore/http/request";

const request = new Request(process.env.VUE_APP_WESTORE_BASE_URL);
export default class WestoreAuth {
  static register = "/api/register";
  static login = "/api/login";
  static user = "/api/auth/user";
  static logout = "/api/logout";
  static validate = "/api/auth/validate";
  static reset_password_request = "/api/reset-password";
  static validate_user_permissions = "/api/permissions";
  static csrf = "/sanctum/csrf-cookie";

  static Register(data) {
    return request.post(WestoreAuth.register, data);
  }

  static Login(data) {
    return request.post(WestoreAuth.login, data);
  }

  static CSRF() {
    return request.get(WestoreAuth.csrf);
  }

  static Logout() {
    return request.post(WestoreAuth.logout);
  }

  static ForgotPassword(email) {
    return request.post(WestoreAuth.reset_password_request, { email });
  }

  static ResetPassword(token, payload) {
    return request.post(
      WestoreAuth.reset_password_request + `/${token}`,
      payload
    );
  }

  static User() {
    return request.get(WestoreAuth.user);
  }

  static WithCredentials(bearer_token) {
    request.withCredentials(bearer_token);
    return this;
  }

  static Validate() {
    return request.get(WestoreAuth.validate);
  }
  static ValidateUserPermissions() {
    return request.get(WestoreAuth.validate_user_permissions);
  }
}
